import { render } from "./Insurances.vue?vue&type=template&id=76984468&scoped=true"
import script from "./Insurances.vue?vue&type=script&lang=js"
export * from "./Insurances.vue?vue&type=script&lang=js"

import "./Insurances.vue?vue&type=style&index=0&id=76984468&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76984468"]])

export default __exports__